/* eslint-disable @typescript-eslint/no-explicit-any */
"use client";

import React, { useState } from "react";
import { FaCheck, FaRegPaperPlane, FaSpinner } from "react-icons/fa";
import { useTranslations } from "use-intl";
import { Button } from "./button";

const NewsLetter: React.FC = () => {
  const t = useTranslations("NewsletterComponent");

  const [email, setEmail] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [completed, setCompleted] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    setCompleted(false);

    try {
      const response = await fetch("/api/lead/newsletter", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      if (!response.ok) {
        throw new Error("Erro ao assinar a newsletter.");
      }

      setEmail("");
    } catch (err: any) {
      console.error(err.message);
    } finally {
      setCompleted(true);
      setEmail("")
      setTimeout(() => {
        setCompleted(false);
        setLoading(false);
      }, 3_000);
    }
  };

  return (
    <form
      className="flex flex-wrap sm:flex-nowrap gap-y-4"
      aria-labelledby="newsletter-title"
      aria-describedby="newsletter-description"
      onSubmit={handleSubmit}
    >
      <label htmlFor="newsletter-email" className="sr-only">
        {t("email_placeholder")}
      </label>
      <input
        id="newsletter-email"
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("email_placeholder")}
        className="flex-grow bg-gray-100 text-black-600 max-[387px]:rounded-r-lg text-base rounded-r-none rounded-l-lg py-2 px-4 focus:outline-none focus:ring-primary focus:border-transparent"
        autoComplete="off"
        aria-required="true"
        required
        disabled={loading || completed}
      />
      <Button
        type="submit"
        label={
          completed ? (
            <>
              <FaCheck />
              <span className="sr-only">{t("completed")}</span>
            </>
          ) : loading ? (
            <>
              <FaSpinner className="animate-spin" />
              <span className="sr-only">{t("subscribing")}</span>
            </>
          ) : (
            <>
              <FaRegPaperPlane />
              <span className="sr-only">{t("subscribe")}</span>
            </>
          )
        }
        disabled={loading}
        className="font-semibold py-2 px-6 max-[387px]:rounded-l-lg max-[387px]:rounded-r-lg transition-colors duration-300 max-[387px]:w-full flex items-center justify-center"
      />
    </form>
  );
};

export default NewsLetter;
